import styled from "styled-components";

export const GameWrapper = styled.div`
  display: grid;
  background-color: #1b2026;
  .banner-img {
    background-image: url("about-banner.png");
  }
`;